module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active || _vm.locked),
      expression: "active||locked"
    }],
    class: ['spinner spinner-gritcode', _vm.spinnerSize, {
      'spinner-fixed': _vm.fixed
    }]
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('div', {
    staticClass: "spinner-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c7c14d62", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7c14d62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Spinner.vue
// module id = 165
// module chunks = 0